import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { GuestService } from '../services/guest.service';
import { DEFAULT_LANGUAGE_CODE, DEFAULT_LANGUAGE_ID } from '../constants/commonenums';
import { LanguageCode } from '../Models/WidgetSettingsModels';
import { getLanguageFromQueryParam, getLanguageFromRouteParam } from 'src/app/app-initializer';

@Pipe({
    name: 'localizeDate',
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private gs: GuestService) {}

  transform(value: Date | string, formatDate = 'mediumDate'): string {
   // Keep English as the safe default locale.
   // Root cause of the runtime error: when locale resolution returns undefined,
   // moment(...).locale(undefined) can behave like a getter and break chained format() calls.
   let localeValue = 'en';
   const localMoment = moment(value);
   const url = new URL(window.location.href);

   // Priority order:
   // 1) language from route/query params
   // 2) language from session storage
   // 3) fallback to 'en'
   const language = getLanguageFromRouteParam(url) || getLanguageFromQueryParam(url);
   if (language) {
     const languageKey = String(language).toLowerCase();
     const mappedLocale = (LanguageCode as any)[languageKey] as string | undefined;
     localeValue = mappedLocale || localeValue;
   } else {
     localeValue = sessionStorage.getItem('languageCode') || localeValue;
   }

   // Avoid rendering-time exceptions for invalid/empty date inputs.
   if (!localMoment.isValid()) {
     return '';
   }

   // Always set a resolved locale before formatting.
   const resolvedLocale = localeValue || 'en';
   localMoment.locale(resolvedLocale);
   return localMoment.format(formatDate);
  }
}